import { useState, useEffect } from 'react'
import { Icon } from './Layout'
import { getAnnouncements } from '../services/announcements'

// Compact pinned cards shown above the category tabs so they stay visible on
// every category. Order comes straight from the API (most recently pinned first).
export default function PinnedAnnouncements() {
  const [pinned, setPinned] = useState([])
  const [openId, setOpenId] = useState(null)

  useEffect(() => {
    let cancelled = false
    getAnnouncements()
      .then(list => { if (!cancelled) setPinned(list.filter(a => a.isPinned)) })
      .catch(() => {})
    return () => { cancelled = true }
  }, [])

  if (pinned.length === 0) return null

  return (
    <div className="flex flex-col gap-2">
      {pinned.map(item => {
        const open = openId === item.id
        return (
          <button
            key={item.id}
            type="button"
            onClick={() => setOpenId(open ? null : item.id)}
            className="w-full text-left bg-surface-container border-2 border-primary-container border-l-[6px] p-3 flex items-start gap-2 hover:bg-primary-container/10 transition-colors"
          >
            <Icon name="push_pin" filled className="text-[18px] text-primary-container shrink-0 mt-0.5" />
            <span className="min-w-0 flex-1">
              <span className="block font-extrabold text-[13px] leading-tight text-on-surface break-words">{item.title}</span>
              <span className={`block text-[12px] text-on-surface-variant mt-1 break-words ${open ? 'whitespace-pre-wrap' : 'line-clamp-1'}`}>
                {item.body}
              </span>
            </span>
            <Icon name={open ? 'expand_less' : 'expand_more'} className="text-[18px] text-on-surface-variant shrink-0" />
          </button>
        )
      })}
    </div>
  )
}
